import React, { Component } from "react";
import { connect } from "react-redux";
import { PageHeader, message, Tooltip, Popconfirm } from "antd";
import {
  FilePdfOutlined,
  FileProtectOutlined,
  EyeOutlined,
  CheckCircleOutlined,
  StopOutlined,
} from "@ant-design/icons";
import {
  ButtonItem,
  SegmentedItem,
  TableItemDinamico,
} from "../../../Components/Items";
import { dineroDisabledMask } from "../../../Components/Items";
import moment from "moment";
import ModalPolizaSeguro from "./ModalPolizaSeguro/ModalPolizaSeguro";
import axios from "axios";
import { EditOutlined } from "@ant-design/icons";
import ModalPolizaSeguroPdf from "./ModalPolizaSeguroPdf/ModalPolizaSeguroPdf";
import ModalUsosPoliza from "./ModalUsosPoliza/ModalUsosPoliza";
class PolizasSeguros extends Component {
  state = {
    loading: false,
    totalRecords: 0,
    valor: 1,
    registros: [],
    modalPoliza: false,
    polizaSeleccionada: null,
    modalUsos: false,
    polizaUsos: null,
  };

  consultarPolizas = async (params) => {
    this.setState({ loading: true });
    try {
      const payload = {
        ...params,
        empresaId: this.props.empresaId,
        valor: this.state.valor,
      };

      const response = await axios.post(
        "/polizasSeguro/selectPolizas",
        payload,
        { headers: this.props.headersToken },
      );

      if (response.data.success === 2) {
        this.setState({
          registros: response.data.data,
          totalRecords: response.data.total,
        });
      } else {
        message.error("Error al cargar las pólizas");
      }
    } catch (error) {
      message.error("Error de conexión con el servidor");
    } finally {
      this.setState({ loading: false });
    }
  };

  abrirModalCrear = () => {
    this.setState({ visibleModal: true, polizaSeleccionada: null });
  };

  abrirModalEditar = (record) => {
    this.setState({ visibleModal: true, polizaSeleccionada: record });
  };

  cambiarEstado = async (polizaId, nuevoEstado) => {
    this.setState({ loading: true });
    const payload = {
      empresaId: this.props.empresaId,
      polizaId: polizaId,
      nuevoEstado: nuevoEstado,
    };
    axios
      .post("/polizasSeguro/cambiarEstadoPoliza", payload, {
        headers: this.props.headersToken,
      })
      .then((res) => {
        if (res.data.success === 2) {
          message.success(res.data.message);
          this.tableRef.fetchData();
        } else {
          message.error(res.data.message || "Error al cambiar el estado.");
        }
      })
      .catch((error) => {
        message.error("Error de conexión al cambiar el estado.");
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  render() {
    const columns = [
      {
        title: "No°",
        dataIndex: "numero",
        key: "numero",
        sorter: (a, b) => {
          if (a.numero < b.numero) {
            return -1;
          }
          if (a.numero > b.numero) {
            return 1;
          }
          return 0;
        },
        buscar: "numero",
      },
      {
        title: "Aseguradora",
        dataIndex: "aseguradora",
        key: "aseguradora",
        sorter: (a, b) => {
          if (a.aseguradora < b.aseguradora) {
            return -1;
          }
          if (a.aseguradora > b.aseguradora) {
            return 1;
          }
          return 0;
        },
        buscar: "aseguradora",
      },
      {
        title: "Descripción",
        dataIndex: "descripcion",
        key: "descripcion",
        sorter: (a, b) => {
          if (a.descripcion < b.descripcion) {
            return -1;
          }
          if (a.descripcion > b.descripcion) {
            return 1;
          }
          return 0;
        },
        buscar: "descripcion",
      },
      {
        title: "Periodo de Vigencia",
        key: "fechaInicio",
        responsive: ["md"],
        render: (_, record) => (
          <div style={{ fontSize: "12px" }}>
            {moment(record.fechaInicio).locale("es").format("DD/MM/YY")}
            {record.fechaFin && (
              <> - {moment(record.fechaFin).locale("es").format("DD/MM/YY")}</>
            )}
          </div>
        ),
        ellipsis: true,
        align: "center",
      },
      {
        title: "Monto x Pago / Total",
        dataIndex: "montoPago",
        key: "montoPago",
        responsive: ["md"],
        sorter: true,
        buscar: "montoPago",
        render: (_, record) => (
          <div style={{ textAlign: "right" }}>
            <div style={{ fontSize: "12px", color: "#666" }}>
              {dineroDisabledMask(record.montoPago)} {record.moneda}
            </div>
            <div style={{ fontWeight: "bold", fontSize: "12px" }}>
              {dineroDisabledMask(record.total)} {record.moneda}
            </div>
          </div>
        ),
        align: "right",
      },
      {
        title: "Total",
        dataIndex: "total",
        key: "total",
        sorter: true,
        buscar: "total",
        responsive: [],
        width: 0,
      },
      {
        title: "Frecuencia de Pago",
        dataIndex: "frecuenciaPago",
        key: "frecuenciaPago",
        sorter: (a, b) => {
          if (a.frecuenciaPago < b.frecuenciaPago) {
            return -1;
          }
          if (a.frecuenciaPago > b.frecuenciaPago) {
            return 1;
          }
          return 0;
        },
      },
      {
        title: "Acción",
        dataIndex: "accion",
        key: "accion",
        fixed: "right",
        width: 150,
        align: "center",
        onCell: () => ({
          className: "acciones-sin-hover",
        }),
        render: (_, record) => {
          let buttons = [];

          if (record.estado === 1) {
            //Boton de editar
            if (this.props.permisoEditarPolizasSeguro) {
              buttons.push(
                <Tooltip
                  title="Editar Poliza"
                  placement="top"
                  overlayInnerStyle={{
                    fontSize: "10px",
                    padding: "1px 5px",
                    minHeight: "auto",
                  }}
                >
                  <ButtonItem
                    key={`editar-${record._id}`}
                    type="default"
                    size="small"
                    lima
                    icon={<EditOutlined />}
                    onClick={() => this.abrirModalEditar(record)}
                  ></ButtonItem>
                </Tooltip>,
              );
            }

            // Boton de generar PDF
            buttons.push(
              <Tooltip
                title="Ver PDF"
                placement="top"
                overlayInnerStyle={{
                  fontSize: "10px",
                  padding: "1px 5px",
                  minHeight: "auto",
                }}
              >
                <ButtonItem
                  key={`editar-${record._id}`}
                  type="default"
                  size="small"
                  cyan
                  icon={<FilePdfOutlined />}
                  onClick={() =>
                    this.setState({
                      verPdf: true,
                      polizaIdPdf: record._id,
                      polizaNumPdf: record.numero,
                    })
                  }
                ></ButtonItem>
              </Tooltip>,
            );

            //Boton para ver los proyectos relacionados
            buttons.push(
              <Tooltip
                title="Ver Proyectos Asociados"
                key={`usos-${record._id}`}
              >
                <ButtonItem
                  key="btn-usos"
                  type="default"
                  size="small"
                  lila
                  icon={<EyeOutlined />}
                  onClick={() =>
                    this.setState({
                      modalUsos: true,
                      polizaUsos: record._id,
                    })
                  }
                />
              </Tooltip>,
            );

            // Deshabilitar
            if (this.props.permisoHabilitarPolizasSeguro) {
              buttons.push(
                <Tooltip
                  title="Deshabilitar"
                  key={`deshabilitar-${record._id}`}
                >
                  <Popconfirm
                    key={`pop-des-${record._id}`}
                    title="¿Deshabilitar esta póliza?"
                    onConfirm={() => this.cambiarEstado(record._id, 0)}
                    okText="Sí"
                    cancelText="No"
                  >
                    <ButtonItem
                      key={`deshabilitar-${record._id}`}
                      type="default"
                      size="small"
                      rojo
                      icon={<StopOutlined />}
                    />
                  </Popconfirm>
                </Tooltip>,
              );
            }
          } else if (record.estado === 0) {
            // Habilitar
            if (this.props.permisoHabilitarPolizasSeguro)
            {
                buttons.push(
                  <Tooltip
                    title="Habilitar"
                    key={`habilitar-tool-${record._id}`}
                  >
                    <ButtonItem
                      key={`habilitar-${record._id}`}
                      type="default"
                      size="small"
                      verde
                      icon={<CheckCircleOutlined />}
                      onClick={() => this.cambiarEstado(record._id, 1)}
                    />
                  </Tooltip>,
                );
            }
          }

          return <div className="acciones-container">{buttons}</div>;
        },
      },
    ];
    return (
      <>
        <PageHeader
          title={
            <span>
              <FileProtectOutlined size={22} />
              Polizas de Seguro
            </span>
          }
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <>
              {window.innerWidth > 1000 && (
                <SegmentedItem
                  options={[
                    { label: "Vigentes", value: 1 },
                    { label: "Vencidas", value: 2 },
                    { label: "Deshabilitas", value: 0 },
                    { label: "Todos", value: 3 },
                  ]}
                  value={this.state.valor}
                  onChange={(val) => {
                    this.setState({ valor: val }, () => {
                      this.tableRef.fetchData();
                    });
                  }}
                />
              )}
              {this.props.permisoAgregarPolizasSeguro && (
                <ButtonItem
                  type="primary"
                  key="agregarProyecto"
                  olivo
                  onClick={this.abrirModalCrear}
                   className="botonAgregar"
                >
                  Agregar Poliza
                </ButtonItem>
              )}
            </>
          }
        />

        <TableItemDinamico
          ref={(ref) => (this.tableRef = ref)}
          onRef={(ref) => (this.tableRef = ref)}
          totalRecords={this.state.totalRecords}
          loading={this.state.loading}
          dataSource={this.state.registros}
          columns={columns}
          pagination={false}
          onFetchData={this.consultarPolizas}
          size="small"
          filterStorageKey={"PolizasSeguro" + this.props.empresaId}
        />
        <ModalPolizaSeguro
          visible={this.state.visibleModal}
          poliza={this.state.polizaSeleccionada}
          empresaId={this.props.empresaId}
          onCancel={() => this.setState({ visibleModal: false })}
          onSuccess={() => {
            this.tableRef.fetchData();
          }}
        />
        <ModalPolizaSeguroPdf
          visible={this.state.verPdf}
          polizaId={this.state.polizaIdPdf}
          polizaNumero={this.state.polizaNumPdf}
          onCancel={() => this.setState({ verPdf: false })}
        />

        <ModalUsosPoliza
          visible={this.state.modalUsos}
          polizaId={this.state.polizaUsos}
          empresaId={this.props.empresaId}
          headersToken={this.props.headersToken}
          onCancel={() => this.setState({ modalUsos: false, polizaUsos: null })}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    permisoAgregarPolizasSeguro:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6998f52ba42a498a7a6cac31",
      )?.activado,
    permisoEditarPolizasSeguro:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6998f53da42a498a7a6cac32",
      )?.activado,
    permisoHabilitarPolizasSeguro:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6998f579a42a498a7a6cac33",
      )?.activado,
  };
};

export default connect(mapStateToProps)(PolizasSeguros);
